/**
 * Tanggal berlaku halaman kebijakan (/privasi, /syarat, /refund).
 *
 * Satu konstanta untuk ketiganya supaya tanggal "terakhir diperbarui" tidak
 * pernah berbeda-beda antar halaman. WAJIB diperbarui manual setiap kali isi
 * salah satu halaman kebijakan berubah secara substantif — jangan diganti
 * dengan tanggal otomatis (new Date()), karena itu membuat kebijakan terlihat
 * "baru diperbarui" setiap hari padahal isinya tidak berubah.
 */
export const TANGGAL_KEBIJAKAN = '14 September 2026'

/** Masa retensi berkas, sesuai konstanta RetensiDefault di internal/jobs/cleanup.go. */
export const RETENSI_BERKAS_JAM = 24
